export default "__VITE_ASSET__DtObR5WQ__"